import { render, staticRenderFns } from "./AddressPlanningSpecifications.vue?vue&type=template&id=159c030d&scoped=true&lang=pug&"
import script from "./AddressPlanningSpecifications.vue?vue&type=script&lang=ts&"
export * from "./AddressPlanningSpecifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c030d",
  null
  
)

export default component.exports